import { Box, Flex } from '@qga/roo-ui/components';
import pluralize from 'pluralize';

import { getTravellersCount } from '@shared/utils';
import Dropdown from '@shared/v2/components/Dropdown';
import { DropdownPosition } from '@shared/v2/components/Dropdown/types';
import { ValidationError } from '@shared/v2/hooks/usePackageSearch';

import LegacyTravellersInputDropdown from '@/components/Travellers/components/TravellersFormDropdown';
import Input, { InputProps } from '@/v2/components/ui/Input/Input';
import { Travellers } from '@/v2/services/sanity/types/api/response';

interface TravellersInputProps extends Pick<InputProps, 'disabled'> {
  travellers: Travellers;
  error?: ValidationError;
  onDataChange: (travellers: Travellers) => void;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  position?: DropdownPosition;
  fullWidthDropdown?: boolean;
}

const TravellersInput = ({
  travellers,
  error,
  disabled,
  onDataChange,
  isOpen,
  onClose,
  onOpen,
  position = 'BOTTOM_RIGHT',
  fullWidthDropdown = false,
}: TravellersInputProps) => {
  const travellersCount = getTravellersCount(travellers);

  return (
    <Box data-testid="TRAVELLERS_INPUT_WRAPPER" id="travellers">
      <Dropdown
        isOpen={isOpen}
        position={position}
        toggle={(ref) => {
          return (
            <Flex ref={ref}>
              <Box width="100%">
                <Input
                  label="Travellers"
                  placeholder="Select travellers"
                  icon="person"
                  height="68px"
                  dataTestId="TRAVELLERS_INPUT"
                  onClick={onOpen}
                  value={
                    travellersCount > 0
                      ? pluralize('traveller', travellersCount, true)
                      : undefined
                  }
                  error={error?.travellers}
                  disabled={disabled}
                />
              </Box>
            </Flex>
          );
        }}
        content={
          <LegacyTravellersInputDropdown
            fullWidth={fullWidthDropdown}
            occupants={travellers}
            onCancel={onClose}
            onSubmit={(travellers: Travellers) => {
              onDataChange(travellers);
              onClose();
            }}
          />
        }
      />
    </Box>
  );
};

export default TravellersInput;
